<template>
  <div
    class="product-info"
    tabindex="0"
    :aria-label="`${checked ? '已选中' : '未选中'}，${showSkuInfo.spuName}${checked ? showSkuInfo.specValue : ''}`"
  >
    <div
      class="check-box"
      tabindex="0"
      role="checkbox"
      :aria-checked="`${checked ? 'true' : 'false'}`"
      @click="selectSku(showSkuInfo)"
    >
      <v-icon v-if="!checked" class="unselected" name="unselected-v2"></v-icon>
      <div v-else class="selected">
        <v-icon class="icon" name="check-mark"></v-icon>
      </div>
    </div>
    <div class="detail-container" tabindex="0" aria-label="点击查看商品详情" @click="goToDetail(showSkuInfo)">
      <img v-lazy="showSkuInfo.imgUrl" alt="" />
      <div class="detail">
        <div class="title lc-2">{{ skuList.length > 1 ? showSkuInfo.spuName : showSkuInfo.skuName }}</div>
        <div
          role="radiogroup"
          v-if="skuList.length > 1"
          ref="skuInfo"
          class="sku-info"
          :aria-label="`${checked ? '已选中' + showSkuInfo.specValue : ''}，可切换商品规格`"
          :class="showMore ? 'sku-info-more' : ''"
        >
          <div
            class="sku-item"
            :class="additionSkuList.includes(item.skuId) ? 'selected' : ''"
            v-for="(item, index) in showSkuList"
            :key="index"
            tabindex="0"
            role="radio"
            :aria-checked="`${additionSkuList.includes(item.skuId) ? 'true' : 'false'}`"
            :aria-label="`${item.specValue}`"
            @click.stop="selectSku(item)"
          >
            {{ item.specValue }}
          </div>
          <div
            class="sku-item show-more"
            v-if="showMoreButton"
            tabindex="0"
            aria-label="点击查看更多规格"
            @click.stop="showAllSku"
          >
            <span>更多</span>
            <v-icon class="icon" name="arrow-left-v3"></v-icon>
          </div>
        </div>
        <div
          class="price"
          :aria-label="`活动价${showSkuInfo.activityPrice}元，${
            showSkuInfo.savePrice ? '原价' + showSkuInfo.salePrice + '元，可省' + showSkuInfo.savePrice + '元' : ''
          }`"
        >
          <span class="sale-price" v-text="showSkuInfo.activityPrice"></span>
          <span class="line-price" v-if="showSkuInfo.savePrice" v-text="`￥${showSkuInfo.salePrice}`"></span>
          <span class="discount-desc" v-if="showSkuInfo.savePrice" v-text="`省${showSkuInfo.savePrice}元`"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { app } from '@/utils'
export default {
  name: 'productItem',
  props: {
    // 加购商品spu维度信息，包含sku
    productItem: {
      type: Object,
      default: () => {}
    },
    // 已选加购商品sku信息
    additionSkuList: {
      type: Array,
      default: () => []
    },
    // 已选加购商品spu信息
    additionSpuList: {
      type: Array,
      default: () => []
    },
    // 埋点上报参数 1:已选模块 2:立即购买 3:镭雕 4:购物车 5:其他
    trackSource: [Number, String]
  },
  data() {
    return {
      hidenIndex: this.productItem.additionSkus.length,
      showMoreButton: false,
      showMore: false
    }
  },
  watch: {
    isShowSkuSelect: {
      handler(val) {
        if (val && !this.showMore) {
          this.$nextTick(() => {
            this.checkShowMore()
          })
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('detailv3', ['selectParams', 'showAdditCommInfo', 'isShowSkuSelect']),
    ...mapGetters('detailv3', ['skuId']),
    // 页面显示的sku规格
    showSkuList() {
      return this.skuList.filter((item, index) => {
        return index < this.hidenIndex
      })
    },
    // 展示的sku信息
    showSkuInfo() {
      let info = {}
      this.showAdditCommInfo.forEach(el => {
        if (el.spuId == this.productItem.spuId) {
          info = el
        }
      })
      return info
    },
    // 实际的sku规格信息
    skuList() {
      this.productItem.additionSkus.forEach(element => {
        element.savePrice = parseFloat((element.salePrice - element.activityPrice).toFixed(2))
        element.spuId = this.productItem.spuId
        element.spuName = this.productItem.spuName
      })
      return this.productItem.additionSkus
    },
    checked() {
      return this.additionSpuList.includes(this.productItem.spuId)
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.checkShowMore()
    // })
  },
  methods: {
    goToDetail(skuItem) {
      this.$track({
        cfrom: '154|005|01|077',
        event_id: '154|005|01|077',
        content: skuItem.skuId,
        sku_id: this.skuId,
        clickPos: 1,
        source: this.trackSource
      })
      const link = `${this.linkBase}/product/${skuItem.spuId}?skuId=${skuItem.skuId}`
      app.openNewWebview({
        url: link
      })
    },
    checkShowMore() {
      if (this.skuList.length > 1) {
        let parentNode = this.$refs.skuInfo
        let children = parentNode.children
        const containerHeight = parentNode.offsetHeight + parentNode.offsetTop
        for (let i = 0; i < children.length; i++) {
          const childBottom = children[i].offsetTop + children[i].offsetHeight
          if (childBottom > containerHeight) {
            this.showMoreButton = true
            this.hidenIndex = i
            break
          }
        }
        if (this.showMoreButton) {
          this.$nextTick(() => {
            this.checkHidenIndex()
          })
        }
      }
    },
    checkHidenIndex() {
      let parentNode = this.$refs.skuInfo
      let children = parentNode.children[this.hidenIndex]
      const containerHeight = parentNode.offsetHeight + parentNode.offsetTop
      const childBottom = children.offsetTop + children.offsetHeight
      if (childBottom > containerHeight) {
        this.hidenIndex = this.hidenIndex - 1
      }
    },
    showAllSku() {
      this.hidenIndex = this.skuList.length
      this.showMoreButton = false
      this.showMore = true
      // 无障碍聚焦规格
      this.$refs.skuInfo.children[0].focus()
      // 更多按钮
      this.$track({
        cfrom: '154|005|01|077',
        event_id: '154|005|01|077',
        content: this.showSkuInfo.skuId,
        sku_id: this.skuId,
        clickPos: 5,
        source: this.trackSource
      })
    },
    selectSku(skuItem) {
      this.$emit('selectSku', skuItem)
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
